// extracted by mini-css-extract-plugin
export default {"PolicyTemplate":"PolicyTemplate___CnvZf","header":"header___v4HqO","navs":"navs___GRwiI","content":"content___d0IYh"};